import {
  parse,
  stringify,
  Replacer
} from "lossless-json";

export const getStringJson = (body?: string) => {
  if (body) {
    try {
      return customStringify(customParse(body), null, 2);
    } catch {
      return body;
    }
  } else {
    return "";
  }
}

export const customParse = (body: string) => {
  return parse(body, null, (value) => {
    if (/^-?\d+$/.test(value)) {
      const num = Number(value);
      if (!Number.isSafeInteger(num)) {
        return BigInt(value);
      } else {
        return num;
      }
    }
    return parseFloat(value);
  });
}

export const customStringify = (body: unknown, replacer?: Replacer | null, space?:  number | string): string => {
  return stringify(body, replacer, space) || "";
}